import docImage from "../assets/svgs/doc-image.svg";
export const folderData = [
  {
    folderName: "Sales Strategies",
    lastModified: "14th Aug‘24",
    fileCount: 2,
  },
  {
    folderName: "Product Marketing Materials",
    lastModified: "14th Aug‘24",
    fileCount: 2,
  },
  {
    folderName: "Agent Training & Resources",
    lastModified: "14th Aug‘24",
    fileCount: 2,
  },
  {
    folderName: "Client Engagement",
    lastModified: "14th Aug‘24",
    fileCount: 2,
  },
];
export const fileData = [
  {
    fileName: "File 1",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 2",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 3",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 4",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 1",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 2",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 3",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
  {
    fileName: "File 4",
    lastModified: "14th Aug‘24",
    docImage: docImage,
  },
];
